//THIS MODEL WAS ADDED AFTER WE DECIDED NOT TO USE THE API MODELLER ANYMORE!


export class Case {
  siteId: string;
  caseId: string;
  stage: string;


  // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
* DO NOT MODIFY, your changes will be lost on next generation!
* Generated code from template &quot;model-json.velocity&quot;
*/

  /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

  public static mergeJSON(instance: any, data: any): Case {
      if (!data) { return instance; }
      if (data.siteId != null) {instance.siteId = data.siteId; }
      if (data.caseId != null) {instance.caseId = data.caseId; }
      if (data.stage != null) {instance.stage = data.stage; }

      return instance; // ir
  }

  public fromJSON(data: any): this { // cbn001
      return Case.mergeJSON(this, data) as any;
  }

  public static mergeJSONFromObject(target: any, object: Case) {
      // TODO: mapping
      return object;
  }

  // toJSON ensures that only class-defined fields are exported.
  public toJSON() {
      return Case.mergeJSONFromObject({}, this);
  }

  // Compares this AppInfo instance with another AppInfo instance, recursively.
  // Transient fields are not considered.
  public equals(other:Case): boolean {
      return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
  }

  /** ---- */


/** end of template &quot;model-json.velocity&quot; */

  // </editor-fold>

}


/** end of template "model.velocity" */
